import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import { get } from 'lodash';
import { getStatusSelectFilterOptions } from '$app/shared/components/StatusSelectFilter/filterOptions';

export default function StatusSelectFilter({ onChange, value, style }) {
  const renderOptions = () =>
    getStatusSelectFilterOptions().map(({ label: groupLabel, options: groupOpts }) => (
      <Select.OptGroup label={groupLabel} key={groupLabel}>
        {groupOpts.map(({ id, label }) => (
          <Select.Option key={id} value={id}>
            {label}
          </Select.Option>
        ))}
      </Select.OptGroup>
    ));

  return (
    <div className={`filter-container ${value ? 'active' : ''}`} style={style}>
      <img src="/assets/icons/filters/tag.svg" alt="Status filter" />
      <Select value={get(value, 'id', 'none')} onChange={onChange} style={{ width: '150%' }}>
        <Select.Option value="" disabled>
          Select Status
        </Select.Option>
        <Select.Option value="none">All Statuses</Select.Option>
        {renderOptions()}
      </Select>
    </div>
  );
}

StatusSelectFilter.propTypes = {
  onChange: PropTypes.any.isRequired,
  value: PropTypes.any,
  style: PropTypes.any,
};

StatusSelectFilter.defaultProps = {
  value: null,
  style: null,
};
